// extracted by mini-css-extract-plugin
module.exports = {"wgvwonx":"wgvwonx","edliwny":"edliwny","ehtpyuh":"ehtpyuh"};